
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.312 26.655C42.312 18.01 35.302 11 26.655 11 18.01 11 11 18.01 11 26.655c0 8.646 7.01 15.656 15.655 15.657 4.274 0 8.147-1.715 10.972-4.49a1 1 0 01.194-.195 15.604 15.604 0 004.49-10.972zm2 0a17.59 17.59 0 01-4.486 11.757l10.881 10.881a1 1 0 11-1.414 1.414l-10.88-10.88a17.59 17.59 0 01-11.758 4.485C16.905 44.312 9 36.406 9 26.655 9 16.905 16.905 9 26.655 9c9.751 0 17.656 7.904 17.657 17.655z"}})])
          )
        }
      }
    